<template>
  <!-- trendAnalysis -->
  <div id="trendAnalysis" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6 slot="header">차트 조회 옵션</h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="getDeviceId(search.stid)"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>디바이스</label>
                <b-form-select
                  v-model="search.device"
                  :options="search.deviceOptions"
                  @change="getSensorAlias"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>센서</label>
                <b-form-select
                  v-model="search.sensorAlias"
                  :options="search.sensorAliasOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Freq</label>
                <b-form-select
                  v-model="search.freq"
                  :options="search.freqOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>시작 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.startDate"
                  :max="search.endDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>종료 일자 </label>
                <b-form-input
                  type="date"
                  v-model="search.endDate"
                  :min="search.startDate"
                  :max="search.maxDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row v-show="isStaticSensor(deviceType)">
              <b-col>
                <label>온도 영향 제거</label>
                <b-form-select
                  v-model="excludeTemp"
                  :options="excludeTempOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >조회</b-button
                >
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea">
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div>
                <label class="pb2">총 데이터 수</label>
                <b-form-input v-model="totalDataCount" disabled></b-form-input>
              </div>
              <div>
                <b-button
                  class="excelBtn"
                  @click="excelDownload"
                  :disabled="totalDataCount == null"
                  ><i class="fas fa-download"></i>다운로드</b-button
                >
              </div>
            </div>
            <b-card
              class="border0"
              body-class="h-100 p20"
              style="height: calc(100vh - 197px) !important; overflow-y: auto"
            >
              <b-row
                style="height: 40px"
                v-if="isDynamicSensor(search.deviceType) && !isCableTensionSensor(search.currentSensor.modelName)"
              >
                <b-col>
                  <b-form-group class="radio-btn">
                    <b-form-radio-group
                      v-model="selectedAnal"
                      :options="analOptions"
                      v-on:change="setChart"
                      buttons
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="pb10" style="height: 220px">
                <b-col>
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart4 }}
                      <!-- <span v-show="search.deviceType === '2' && initval != 0">&nbsp;(초기값: {{ initval }})</span> -->
                    </h6>
                    <div id="chart4" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="pb10" style="height: 600px">
                <b-col class="w-60 pr5" style="flex-basis: unset">
                  <b-row class="h-33">
                    <b-col class="pr10">
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.chart1 }}
                        </h6>
                        <div id="chart1" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row class="h-33 pt10">
                    <b-col class="pr10">
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.chart2 }}
                        </h6>
                        <div id="chart2" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row class="h-33 pt10">
                    <b-col class="pr10">
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.chart3 }}
                        </h6>
                        <div id="chart3" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="w-40" style="flex-basis: unset">
                  <b-row class="h-50 pb10" style="margin-bottom: -1%">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.chart5 }}
                        </h6>
                        <div id="chart5" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row class="h-50">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.chart6 }}
                        </h6>
                        <div id="chart6" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row
                class="pb10"
                style="height: 350px"
                v-if="isDynamicSensor(search.deviceType) && !isCableTensionSensor(search.currentSensor.modelName)"
              >
                <b-col class="h-100 w-33 pr-1" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.scube_chart7 }}
                        </h6>
                        <div class="data-histogram">
                          <div id="scube_chart7" class="graph chart"></div>
                          <div class="legend">
                            <ul>
                              <li>MEAN: {{ chart.scube_chart7_stat.mean }}</li>
                              <li>STD: {{ chart.scube_chart7_stat.std }}</li>
                              <li class="lvl-1">
                                MIN: {{ chart.scube_chart7_stat.min }}
                              </li>
                              <li class="lvl-1">
                                20%: {{ chart.scube_chart7_stat.percent20 }}
                              </li>
                              <li class="lvl-2">
                                60%: {{ chart.scube_chart7_stat.percent60 }}
                              </li>
                              <li class="lvl-2">
                                70%: {{ chart.scube_chart7_stat.percent70 }}
                              </li>
                              <li class="lvl-2">
                                99%: {{ chart.scube_chart7_stat.percent99 }}
                              </li>
                              <li class="lvl-3">
                                MAX: {{ chart.scube_chart7_stat.max }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="h-100 w-33 pr-1" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.scube_chart8 }}
                        </h6>
                        <div class="data-histogram">
                          <div id="scube_chart8" class="graph chart"></div>
                          <div class="legend">
                            <ul>
                              <li>MEAN: {{ chart.scube_chart8_stat.mean }}</li>
                              <li>STD: {{ chart.scube_chart8_stat.std }}</li>
                              <li class="lvl-1">
                                MIN: {{ chart.scube_chart8_stat.min }}
                              </li>
                              <li class="lvl-1">
                                20%: {{ chart.scube_chart8_stat.percent20 }}
                              </li>
                              <li class="lvl-2">
                                60%: {{ chart.scube_chart8_stat.percent60 }}
                              </li>
                              <li class="lvl-2">
                                70%: {{ chart.scube_chart8_stat.percent70 }}
                              </li>
                              <li class="lvl-2">
                                99%: {{ chart.scube_chart8_stat.percent99 }}
                              </li>
                              <li class="lvl-3">
                                MAX: {{ chart.scube_chart8_stat.max }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="h-100 w-33" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <div id="scube_chart9" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="pb10" style="height: 350px" v-else>
                <b-col class="h-100 w-40 pr-1" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.bgw_chart7 }}
                        </h6>
                        <div class="data-histogram">
                          <div id="bgw_chart7" class="graph chart"></div>
                          <div class="legend">
                            <ul>
                              <li>MEAN: {{ chart.bgw_chart7_stat.mean }}</li>
                              <li>STD: {{ chart.bgw_chart7_stat.std }}</li>
                              <li class="lvl-1">
                                MIN: {{ chart.bgw_chart7_stat.min }}
                              </li>
                              <li class="lvl-3">
                                MAX: {{ chart.bgw_chart7_stat.max }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="h-100 w-30" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.bgw_chart8 }}
                        </h6>
                        <div id="bgw_chart8" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="h-100 w-30 pl-1" style="flex-basis: unset">
                  <b-row class="h-100">
                    <b-col>
                      <b-card
                        class="h-100 default-border1"
                        body-class="h-100 p-0"
                        header-tag="header"
                      >
                        <h6 slot="header">
                          {{ chart.title.bgw_chart9 }}
                        </h6>
                        <div id="bgw_chart9" class="graph"></div>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import chartUtil from "../common/chartUtil";
import utils from "../common/utils";
import moment from "moment";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getCenterBus",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  data() {
    return {
      totalDataCount: null,
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        device: null,
        deviceType: null,
        deviceOptions: [{ value: null, text: "선택" }],
        sensorAlias: null,
        sensorAliasOptions: [{ value: null, text: "선택" }],
        currentSensor: {
          value: null,
          text: null,
          typeCode: null,
          typeName: null,
          modelCode: null,
          modelName: null,
          unit: null,
        },
        freq: "H",
        freqOptions: [
          { value: "60S", text: "1m" },
          { value: "300S", text: "5m" },
          { value: "600S", text: "10m" },
          { value: "1800S", text: "30m" },
          { value: "H", text: "1h" },
          { value: "6H", text: "6h" },
          { value: "12H", text: "12h" },
          { value: "24H", text: "1d" },
        ],
        startDate: null,
        endDate: null,
        btnDisabled: false,
      },
      chart: {
        originalData: null,
        deviceType: null,
        title: {
          chart1: "Trend Analysis",
          chart2: "Seasonal Analysis",
          chart3: "Difference Analysis",
          chart4: "Raw Data",
          chart5: "Boxplot groupped by Hour",
          chart6: "Boxplot groupped by Month",
          bgw_chart7: "Data histogram",
          bgw_chart8: "DATA-TEMPERATURE Scaled PLOT",
          bgw_chart9: "Data excluding temperature effect PLOT",
          scube_chart7: "P-to-P data",
          scube_chart8: "RMS data",
        },
        chart1: [
          {
            x: [],
            y: [],
            name: "",
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
            lines: [],
          },
          {
            x: [],
            y: [],
            name: "",
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
            lines: [],
          },
        ],
        chart2: [
          {
            x: [],
            y: [],
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          },
        ],
        chart3: [
          {
            x: [],
            y: [],
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          },
        ],
        chart4: [
          {
            x: [],
            y: [],
            name: "",
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          },
          {
            x: [],
            y: [],
            name: "",
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          },
        ],
        chart5: [],
        chart6: [],
        bgw_chart7: [
          {
            x: [],
            y: [],
            type: "bar",
          },
        ],
        bgw_chart7_stat: {
          mean: 0,
          max: 0,
          min: 0,
          std: 0,
          percent20: 0,
          percent60: 0,
          percent70: 0,
          percent99: 0,
        },
        bgw_chart8: [],
        bgw_chart9: [],
        scube_chart7: [
          {
            x: [],
            y: [],
            type: "bar",
          },
        ],
        scube_chart7_stat: {
          mean: 0,
          max: 0,
          min: 0,
          std: 0,
          percent20: 0,
          percent60: 0,
          percent70: 0,
          percent99: 0,
        },
        scube_chart8: [
          {
            x: [],
            y: [],
            type: "bar",
          },
        ],
        scube_chart8_stat: {
          mean: 0,
          max: 0,
          min: 0,
          std: 0,
          percent20: 0,
          percent60: 0,
          percent70: 0,
          percent99: 0,
        },
        scube_chart9: [
          {
            x: [],
            y: [],
            mode: "markers",
            type: "scatter",
          },
          {
            x: [],
            y: [],
            mode: "markers",
            type: "scatter",
            marker: {
              size: 11,
              color: "#ff0000",
            },
          },
        ],
      },
      selectedAnal: "ANAL_1",
      analOptions: [
        { value: "ANAL_1", text: "ANAL 1" },
        { value: "ANAL_2", text: "ANAL 2" },
      ],
      LoadYn: false,
      initval: null,
      isFirstCall: true,
      excludeTemp: "N",
      excludeTempOptions: [
        { value: "N", text: "적용 안함" },
        { value: "F", text: "순방향" },
        { value: "B", text: "역방향" },
      ],
      deviceType: "",
    };
  },
  watch: {
    "search.projectid"() {
      this.search.stid = null;
    },
    "search.stid"() {
      this.search.device = null;
      this.search.deviceOptions = [{ value: null, text: "선택" }];
    },
    "search.device": function () {
      if (this.search.device === null) {
        this.search.sensorAlias = null;
        this.search.sensorAliasOptions = [{ value: null, text: "선택" }];
      } else {
        this.deviceType = this.search.device.split("/")[0];
      }
    },
    "search.sensorAlias": function () {
      this.search.currentSensor = this.search.sensorAliasOptions.find(
        (option) => option.value === this.search.sensorAlias
      );
    },
  },
  created() {
    this.getProjectList();
  },
  mounted() {
    this.search.startDate = moment().add(-8, "day").format("YYYY-MM-DD");
    this.search.endDate = moment().add(-1, "day").format("YYYY-MM-DD");
    this.getCenterBus.$on("getDeviceId", (param) => {
      var reqBody = {
        code: param.code,
      };
      this.getDeviceId(reqBody);
    });
    if (this.getSelectedDataStartDate)
      this.search.startDate = this.getSelectedDataStartDate;
    if (this.getSelectedDataEndDate)
      this.search.endDate = this.getSelectedDataEndDate;
  },
  destroyed() {
    this.getCenterBus.$off("getDeviceId");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody) // HICC230608 getProjectListAll
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              PRE: "(준비중)",
              SVC: "",
              IDL: "(휴면)",
              EXP: "(종료)",
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname + projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.getDeviceId(this.search.stid);
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceId(param) {
      var reqBody = {
        stid: param,
      };
      this.$http
        .post("/sensor/getDeviceId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var devlist = res.data.data;
            var options = [{ value: null, text: "선택" }];
            for (let i = 0; i < devlist.length; i++) {
              options.push({
                value: devlist[i].deviceid,
                text: devlist[i].devicename,
              });
            }
            this.search.device = null;
            this.search.deviceType = null;
            this.search.deviceOptions = options;

            if (options.length > 0) {
              if (options[0].value) {
                this.search.device = options[0].value;
              } else {
                this.search.device = options[1].value;
              }
              this.getSensorAlias(this.search.device);
            } else {
              this.getSensorAlias(null);
            }
            this.initData();
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorAlias(param) {
      if (param === null) {
        this.search.sensorAlias = param;
        this.search.sensorAliasOptions = [{ value: null, text: "선택" }];
      } else {
        var devInfo = String(param).split("/");
        var reqBody = {
          deviceid: devInfo[1],
        };
        this.$http
          .post("/sensor/getListOfSensorIdTypeModelUnit", reqBody)
          .then((res) => {
            if (res.data.resultyn === "Y") {
              var sensorlist = res.data.data;
              var options = [{ value: null, text: "선택" }];
              for (let i = 0; i < sensorlist.length; i++) {
                options.push({
                  value: sensorlist[i].id,
                  text: sensorlist[i].name,
                  typeCode: sensorlist[i].typeCode,
                  typeName: sensorlist[i].typeName,
                  modelCode: sensorlist[i].modelCode,
                  modelName: sensorlist[i].modelName,
                  unit: sensorlist[i].unit,
                });
              }
              if (options.length > 1) {
                this.search.sensorAliasOptions = options.slice(1);
                this.search.sensorAlias = options[1].value;
              } else {
                this.search.sensorAliasOptions = options;
                this.search.sensorAlias = null;
              }
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    initData() {
      this.originalData = null;
      this.totalDataCount = null;

      this.chart.chart1[0].x = [];
      this.chart.chart1[0].y = [];
      this.chart.chart1[1].x = [];
      this.chart.chart1[1].y = [];

      this.chart.chart2[0].x = [];
      this.chart.chart2[0].y = [];

      this.chart.chart3[0].x = [];
      this.chart.chart3[0].y = [];

      this.chart.chart4[0].x = [];
      this.chart.chart4[0].y = [];
      this.chart.chart4[1].x = [];
      this.chart.chart4[1].y = [];

      this.chart.chart5 = [];

      this.chart.chart6 = [];

      this.chart.bgw_chart7[0].x = [];
      this.chart.bgw_chart7[0].y = [];
      this.chart.bgw_chart7_stat.mean = 0;
      this.chart.bgw_chart7_stat.max = 0;
      this.chart.bgw_chart7_stat.min = 0;
      this.chart.bgw_chart7_stat.std = 0;
      this.chart.bgw_chart7_stat.percent20 = 0;
      this.chart.bgw_chart7_stat.percent60 = 0;
      this.chart.bgw_chart7_stat.percent70 = 0;
      this.chart.bgw_chart7_stat.percent99 = 0;

      this.chart.bgw_chart8 = [];

      this.chart.bgw_chart9 = [];

      this.chart.scube_chart7[0].x = [];
      this.chart.scube_chart7[0].y = [];
      this.chart.scube_chart7_stat.mean = 0;
      this.chart.scube_chart7_stat.max = 0;
      this.chart.scube_chart7_stat.min = 0;
      this.chart.scube_chart7_stat.std = 0;
      this.chart.scube_chart7_stat.percent20 = 0;
      this.chart.scube_chart7_stat.percent60 = 0;
      this.chart.scube_chart7_stat.percent70 = 0;
      this.chart.scube_chart7_stat.percent99 = 0;

      this.chart.scube_chart8[0].x = [];
      this.chart.scube_chart8[0].y = [];
      this.chart.scube_chart8_stat.mean = 0;
      this.chart.scube_chart8_stat.max = 0;
      this.chart.scube_chart8_stat.min = 0;
      this.chart.scube_chart8_stat.std = 0;
      this.chart.scube_chart8_stat.percent20 = 0;
      this.chart.scube_chart8_stat.percent60 = 0;
      this.chart.scube_chart8_stat.percent70 = 0;
      this.chart.scube_chart8_stat.percent99 = 0;

      this.chart.scube_chart9[0].x = [];
      this.chart.scube_chart9[0].y = [];
      this.chart.scube_chart9[1].x = [];
      this.chart.scube_chart9[1].y = [];

      Plotly.purge("chart1");
      Plotly.purge("chart2");
      Plotly.purge("chart3");
      Plotly.purge("chart4");
      Plotly.purge("chart5");
      Plotly.purge("chart6");

      if (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)) {
        Plotly.purge("scube_chart7");
        Plotly.purge("scube_chart8");
        Plotly.purge("scube_chart9");
      } else {
        Plotly.purge("bgw_chart7");
        Plotly.purge("bgw_chart8");
        Plotly.purge("bgw_chart9");
      }
    },
    getData() {
      if (
        this.search.stid === null &&
        this.search.sensorAlias === null &&
        this.search.dataType === null
      )
        return;
      this.initData();

      var devInfo = String(this.search.device).split("/");
      this.search.deviceType = devInfo[0];
      this.deviceType = devInfo[0];
      var reqBody = {
        deviceId: devInfo[1],
        deviceType: devInfo[0],
        sensoridx: this.search.sensorAlias,
        freq: this.search.freq,
        startDate: moment(this.search.startDate).format("YYYYMMDD"),
        endDate: moment(this.search.endDate).format("YYYYMMDD"),
        excludeTemp: this.excludeTemp,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.search.btnDisabled = true;
      this.LoadYn = true;

      this.$http
        .post("/trendAnalysis/getData", reqBody, { timeout: 5 * 60 * 1000 })
        .then((res) => {
          this.initData();
          this.search.btnDisabled = false;
          this.LoadYn = false;

          if (res.data.resultyn === "Y") {
            this.chart.originalData = res.data.data;
            this.setChart();
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.initData();
          this.search.btnDisabled = false;
          this.LoadYn = false;
          console.error(err);
        });
    },
    setChart() {
      // kyj --> 응답 메시지에 error_msg 및 success 가 없음
      this.search.btnDisabled = true;
      this.LoadYn = true;
      this.initData();

      setTimeout(() => {
        let data = this.chart.originalData;
        this.totalDataCount = data.data_cnt;
        this.initval = data.init_val;

        this.chart.title.chart1 = data.chart1.title;
        this.chart.chart1[0].x = data.x;
        this.chart.chart1[1].x = data.x;
        if (data.initval != null && data.lines != null) {
          if (data.thrmode === "H" || data.thrmode === null) {
            this.chart.chart1[0].lines = [
              data.initval,
              data.initval + data.lines.warn,
              data.initval + data.lines.crit,
              data.initval + data.lines.dang,
            ];
          } else if (data.thrmode === "L") {
            this.chart.chart1[0].lines = [
              data.initval,
              data.initval - data.lines.warn,
              data.initval - data.lines.crit,
              data.initval - data.lines.dang,
            ];
          } else if (data.thrmode === "HL") {
            this.chart.chart1[0].lines = [
              data.initval,
              data.initval - data.lines.warn,
              data.initval - data.lines.crit,
              data.initval - data.lines.dang,
              data.initval + data.lines.warn,
              data.initval + data.lines.crit,
              data.initval + data.lines.dang,
            ];
          }
        }

        this.chart.title.chart2 = data.chart2.title;
        this.chart.chart2[0].x = data.x;

        this.chart.title.chart3 = data.chart3.title;
        this.chart.chart3[0].x = data.x;

        this.chart.title.chart4 = data.chart4.title;
        this.chart.chart4[0].x = data.chart4.x[0].data;
        this.chart.chart4[1].x = data.chart4.x[0].data;

        this.chart.title.chart5 = data.chart5.title;

        this.chart.title.chart6 = data.chart6.title;

        if (
          this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName) &&
          this.selectedAnal === "ANAL_2"
        ) {
          this.chart.chart1[0].y = data.chart1.y2;
          this.chart.chart2[0].y = data.chart2.y2;
          this.chart.chart3[0].y = data.chart3.y2;
        } else if (
          this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName) &&
          this.selectedAnal === "ANAL_1"
        ) {
          this.chart.chart1[0].y = data.chart1.y;
          this.chart.chart2[0].y = data.chart2.y;
          this.chart.chart3[0].y = data.chart3.y;
        } else if (this.isStaticSensor(this.search.deviceType) || this.isCableTensionSensor(this.search.currentSensor.modelName)) {
          this.chart.chart1[0].y = data.chart1.y[0].data;
          this.chart.chart1[1].y = data.chart1.y[1].data;
          this.chart.chart1[0].name = data.chart1.y[0].name;
          this.chart.chart1[1].name = data.chart1.y[1].name;
          this.chart.chart2[0].y = data.chart2.y;
          this.chart.chart3[0].y = data.chart3.y;
        }

        let dataIdx = data.chart4.y.findIndex(
          (x) =>
            x.name ===
            (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)
              ? this.selectedAnal
              : "data")
        );
        let tempIdx = data.chart4.y.findIndex((x) => x.name === "temp");
        this.chart.chart4[0].y = data.chart4.y[dataIdx].data;
        this.chart.chart4[1].y = data.chart4.y[tempIdx].data;
        this.chart.chart4[0].name = data.chart4.y[dataIdx].name;
        this.chart.chart4[1].name = data.chart4.y[tempIdx].name;

        for (let i = 0; i < data.chart5.x.length; i++) {
          let xData = data.chart5.x[i];
          let yData = null;

          if (
            this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName) &&
            this.selectedAnal === "ANAL_2"
          ) {
            yData = data.chart5.y2[i];
          } else {
            yData = data.chart5.y[i];
          }
          this.chart.chart5.push({
            name: xData,
            y: yData,
            type: "box",
            marker: {
              size: 5,
              color: "#2d81d8",
            },
            line: {
              width: 1,
            },
          });
        }

        for (let i = 0; i < data.chart6.x.length; i++) {
          let xData = data.chart6.x[i];
          let yData = null;

          if (
            this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName) &&
            this.selectedAnal === "ANAL_2"
          ) {
            yData = data.chart6.y2[i];
          } else {
            yData = data.chart6.y[i];
          }
          this.chart.chart6.push({
            name: xData,
            y: yData,
            type: "box",
            marker: {
              size: 5,
              color: "#2d81d8",
            },
            line: {
              width: 1,
            },
          });
        }

        if (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)) {
          this.chart.title.scube_chart7 = data.chart7.title;
          this.chart.scube_chart7[0].x = data.chart7.x;
          this.chart.scube_chart7[0].y = data.chart7.y;
          this.chart.scube_chart7_stat.mean = data.chart7.stat.mean;
          this.chart.scube_chart7_stat.max = data.chart7.stat.max;
          this.chart.scube_chart7_stat.min = data.chart7.stat.min;
          this.chart.scube_chart7_stat.std = data.chart7.stat.std;
          this.chart.scube_chart7_stat.percent20 = data.chart7.stat.p20;
          this.chart.scube_chart7_stat.percent60 = data.chart7.stat.p60;
          this.chart.scube_chart7_stat.percent70 = data.chart7.stat.p70;
          this.chart.scube_chart7_stat.percent99 = data.chart7.stat.p99;

          this.chart.title.scube_chart8 = data.chart8.title;
          this.chart.scube_chart8[0].x = data.chart8.x;
          this.chart.scube_chart8[0].y = data.chart8.y;
          this.chart.scube_chart8_stat.mean = data.chart8.stat.mean;
          this.chart.scube_chart8_stat.max = data.chart8.stat.max;
          this.chart.scube_chart8_stat.min = data.chart8.stat.min;
          this.chart.scube_chart8_stat.std = data.chart8.stat.std;
          this.chart.scube_chart8_stat.percent20 = data.chart8.stat.p20;
          this.chart.scube_chart8_stat.percent60 = data.chart8.stat.p60;
          this.chart.scube_chart8_stat.percent70 = data.chart8.stat.p70;
          this.chart.scube_chart8_stat.percent99 = data.chart8.stat.p99;

          for (let i = 0; i < data.chart9.data.length; i++) {
            let xydata = data.chart9.data[i];

            this.chart.scube_chart9[0].x.push(xydata[0]);
            this.chart.scube_chart9[0].y.push(xydata[1]);
          }
          for (let i = 0; i < data.chart9.center.length; i++) {
            let xydata = data.chart9.center[i];

            this.chart.scube_chart9[1].x.push(xydata[0]);
            this.chart.scube_chart9[1].y.push(xydata[1]);
          }
        } else {
          this.chart.title.bgw_chart7 = data.chart7.title;
          this.chart.bgw_chart7[0].x = data.chart7.x;
          this.chart.bgw_chart7[0].y = data.chart7.y;
          this.chart.bgw_chart7_stat.mean = data.chart7.stat.mean;
          this.chart.bgw_chart7_stat.max = data.chart7.stat.max;
          this.chart.bgw_chart7_stat.min = data.chart7.stat.min;
          this.chart.bgw_chart7_stat.std = data.chart7.stat.std;
          this.chart.bgw_chart7_stat.percent20 = data.chart7.stat.p20;
          this.chart.bgw_chart7_stat.percent60 = data.chart7.stat.p60;
          this.chart.bgw_chart7_stat.percent70 = data.chart7.stat.p70;
          this.chart.bgw_chart7_stat.percent99 = data.chart7.stat.p99;

          this.chart.title.bgw_chart8 = data.chart8.title;
          for (let i = 0; i < data.chart8.y.length; i++) {
            let yData = data.chart8.y[i];
            this.chart.bgw_chart8.push({
              x: data.chart8.x[0].data,
              y: yData.data,
              name: yData.name,
              type: "scatter",
              mode: "lines",
              line: { width: 1 },
            });
          }

          this.chart.title.bgw_chart9 = data.chart9.title;
          for (let i = 0; i < data.chart9.y.length; i++) {
            let yData = data.chart9.y[i];
            this.chart.bgw_chart9.push({
              x: data.chart9.x[0].data,
              y: yData.data,
              name: yData.name,
              type: "scatter",
              mode: "lines",
              line: { width: 1 },
            });
          }
        }
        if (
          this.isStaticSensor(this.search.deviceType) &&
          this.excludeTemp === "N"
        ) {
          this.drawDefaultChart2YAxes("chart1", this.chart.chart1);
        } else {
          this.drawLineChart(
            "chart1",
            [
              {
                x: this.chart.chart1[0].x,
                y: this.chart.chart1[0].y,
                type: "scatter",
                mode: "lines",
                line: { width: 1 },
              },
            ],
            true
          );
        }
        this.drawLineChart("chart2", this.chart.chart2, true);
        this.drawLineChart("chart3", this.chart.chart3, true);
        this.drawDefaultChart2YAxes("chart4", this.chart.chart4);
        this.drawDefaultChart("chart5", this.chart.chart5);
        this.drawDefaultChart("chart6", this.chart.chart6);

        if (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)) {
          this.drawDefaultChart("scube_chart7", this.chart.scube_chart7);
          this.drawDefaultChart("scube_chart8", this.chart.scube_chart8);
          this.drawDefaultChart("scube_chart9", this.chart.scube_chart9);
        } else {
          this.drawDefaultChart("bgw_chart7", this.chart.bgw_chart7);
          this.drawDefaultChart("bgw_chart8", this.chart.bgw_chart8);
          this.drawDefaultChart("bgw_chart9", this.chart.bgw_chart9);
        }
        this.search.btnDisabled = false;
        this.LoadYn = false;
      }, 0);
    },
    drawLineChart(id, dataArr, isXaxisHideLabel) {
      var data = dataArr;
      var layout = chartUtil.setDefaultTimeLayout(id, {
        datacnt: dataArr[0].x.length,
        showxaxiscnt: 4,
        annotation: {
          yaxis: {
            text: "Value",
            x: -0.115,
            y: 0.5,
          },
        },
      });
      if (isXaxisHideLabel) {
        layout.xaxis.showticklabels = false;
      }
      if (this.isStaticSensor(this.search.deviceType)) {
        if (dataArr[0].lines != null) {
          layout.shapes = [];
          let color = [
            "#fff",
            "#ff4",
            "#ff8510",
            "#f00",
            "#ff4",
            "#ff8510",
            "#f00",
          ];
          for (let i = 0; i < dataArr[0].lines.length; i++) {
            layout.shapes.push({
              type: "line",
              xref: "paper",
              x0: 0,
              y0: dataArr[0].lines[i],
              x1: 1,
              y1: dataArr[0].lines[i],
              line: {
                color: color[i],
                width: 1,
                dash: "longdash",
              },
            });
          }
        }
      }
      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot(id, data, layout);
    },
    drawDefaultChart(id, dataArr) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);

      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot(id, data, layout);
    },
    drawDefaultChart2YAxes(id, dataArr) {
      var data = dataArr;
      var layout = chartUtil.setDefaultDualAxisLayout(id);

      data[1].yaxis = "y2";

      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot(id, data, layout);
    },
    excelDownload(evt) {
      if (this.totalDataCount === 0) {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk("데이터가 없습니다.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      this.LoadYn = true;
      let contents = [];
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart1),
        header: ["time", "data"],
        content: {
          time: this.chart.chart1[0].x,
          data: this.chart.chart1[0].y,
        },
      });
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart2),
        header: ["time", "data"],
        content: {
          time: this.chart.chart2[0].x,
          data: this.chart.chart2[0].y,
        },
      });
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart3),
        header: ["time", "data"],
        content: {
          time: this.chart.chart3[0].x,
          data: this.chart.chart3[0].y,
        },
      });
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart4),
        header: ["time", "data", "temp"],
        content: {
          time: this.chart.chart4[0].x,
          data: this.chart.chart4[0].y,
          temp: this.chart.chart4[1].y,
        },
      });

      let hour = [];
      let chart5DataArray = [];
      for (let i = 0; i < this.chart.chart5.length; i++) {
        let chart5 = this.chart.chart5[i];
        hour.push(chart5.name);

        let chart5YDataStr = "";
        for (let j = 0; j < chart5.y.length; j++) {
          let chart5YData = chart5.y[j];
          chart5YDataStr += chart5YData + ", ";
        }

        if (chart5YDataStr.length > 1) {
          chart5YDataStr = chart5YDataStr.slice(0, -2);
        }
        chart5DataArray.push(chart5YDataStr);
      }
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart5),
        header: ["hour_string", "data_string"],
        content: {
          hour_string: hour,
          data_string: chart5DataArray,
        },
      });

      let month = [];
      let chart6DataArray = [];
      for (let i = 0; i < this.chart.chart6.length; i++) {
        let chart6 = this.chart.chart6[i];
        month.push(chart6.name);

        let chart6YDataStr = "";
        for (let j = 0; j < chart6.y.length; j++) {
          let chart6YData = chart6.y[j];
          chart6YDataStr += chart6YData + ", ";
        }

        if (chart6YDataStr.length > 1) {
          chart6YDataStr = chart6YDataStr.slice(0, -2);
        }
        chart6DataArray.push(chart6YDataStr);
      }
      contents.push({
        sheetName: this.checkSheetName(this.chart.title.chart6),
        header: ["month_string", "data_string"],
        content: {
          month_string: month,
          data_string: chart6DataArray,
        },
      });

      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      var reqBody = {
        fileName:
          "트랜드 분석_" +
          startDate +
          "_" +
          endDate +
          "(" +
          this.search.stid +
          "_" +
          this.search.device +
          ")_1",
        data: contents,
      };
      this.$http
        .post("/sensor/excelDownload", reqBody, {
          responseType: "arraybuffer",
          timeout: 5 * 60 * 1000,
        })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, reqBody.fileName);
          this.excelDownload_2(evt);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.log(err.response);
          this.setAlertTitle();
          let errorMsg = "엑셀 다운로드 실패";
          if (err.response.status === 500) {
            errorMsg = "데이터의 양이 너무 많습니다";
          }
          this.$bvModal.msgBoxOk(errorMsg, this.getAlertOptions);
        });
    },
    excelDownload_2(evt) {
      this.LoadYn = true;
      let contents = [];
      if (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)) {
        contents.push({
          sheetName: this.checkSheetName(this.chart.title.scube_chart7),
          header: ["point", "data"],
          content: {
            point: this.chart.scube_chart7[0].x,
            data: this.chart.scube_chart7[0].y,
          },
        });
        contents.push({
          sheetName: this.checkSheetName(this.chart.title.scube_chart8),
          header: ["point", "data"],
          content: {
            point: this.chart.scube_chart8[0].x,
            data: this.chart.scube_chart8[0].y,
          },
        });
      } else {
        contents.push({
          sheetName: this.checkSheetName(this.chart.title.bgw_chart7),
          header: ["point", "data"],
          content: {
            point: this.chart.bgw_chart7[0].x,
            data: this.chart.bgw_chart7[0].y,
          },
        });

        let chart8Contents = {
          sheetName: this.checkSheetName(this.chart.title.bgw_chart8),
          header: ["time"],
          content: {
            time: this.chart.bgw_chart8[0].x,
          },
        };
        for (let i = 0; i < this.chart.bgw_chart8.length; i++) {
          let chart8Data = this.chart.bgw_chart8[i];
          let key = chart8Data.name;
          chart8Contents.header.push(key);
          chart8Contents.content[key] = chart8Data.y;
        }
        contents.push(chart8Contents);
      }

      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      var reqBody = {
        fileName:
          "트랜드 분석_" +
          startDate +
          "_" +
          endDate +
          "(" +
          this.search.stid +
          "_" +
          this.search.device +
          ")_2",
        data: contents,
      };
      this.$http
        .post("/sensor/excelDownload", reqBody, {
          responseType: "arraybuffer",
          timeout: 5 * 60 * 1000,
        })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, reqBody.fileName);
          this.excelDownload_3(evt);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.log(err.response);
          this.setAlertTitle();
          let errorMsg = "엑셀 다운로드 실패";
          if (err.response.status === 500) {
            errorMsg = "데이터의 양이 너무 많습니다";
          }
          this.$bvModal.msgBoxOk(errorMsg, this.getAlertOptions);
        });
    },
    excelDownload_3(evt) {
      this.LoadYn = true;
      let contents = [];
      if (this.isDynamicSensor(this.search.deviceType) && !this.isCableTensionSensor(this.search.currentSensor.modelName)) {
        contents.push({
          sheetName: this.checkSheetName("point"),
          header: ["x", "y"],
          content: {
            x: this.chart.scube_chart9[0].x,
            y: this.chart.scube_chart9[0].y,
          },
        });
        contents.push({
          sheetName: this.checkSheetName("center"),
          header: ["x", "y"],
          content: {
            x: this.chart.scube_chart9[1].x,
            y: this.chart.scube_chart9[1].y,
          },
        });
      } else {
        let chart9Contents = {
          sheetName: this.checkSheetName(this.chart.title.bgw_chart9),
          header: ["time"],
          content: {
            time: this.chart.bgw_chart9[0].x,
          },
        };
        for (let i = 0; i < this.chart.bgw_chart9.length; i++) {
          let chart9Data = this.chart.bgw_chart9[i];
          let key = chart9Data.name;
          chart9Contents.header.push(key);
          chart9Contents.content[key] = chart9Data.y;
        }
        contents.push(chart9Contents);
      }

      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      var reqBody = {
        fileName:
          "트랜드 분석_" +
          startDate +
          "_" +
          endDate +
          "(" +
          this.search.stid +
          "_" +
          this.search.device +
          ")_3",
        data: contents,
      };
      this.$http
        .post("/sensor/excelDownload", reqBody, {
          responseType: "arraybuffer",
          timeout: 5 * 60 * 1000,
        })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, reqBody.fileName);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.log(err.response);
          this.setAlertTitle();
          let errorMsg = "엑셀 다운로드 실패";
          if (err.response.status === 500) {
            errorMsg = "데이터의 양이 너무 많습니다";
          }
          this.$bvModal.msgBoxOk(errorMsg, this.getAlertOptions);
        });
    },
    checkSheetName(name) {
      if (name.length >= 30) {
        let minusNum = name.length - 30;
        return name.slice(0, -(minusNum + 4)) + "...";
      } else {
        return name;
      }
    },
    isDynamicSensor: utils.isDynamicSensor,
    isStaticSensor: utils.isStaticSensor,
    isCableTensionSensor: utils.isCableTensionSensor,
  },
};
</script>

<style lang="scss">
#trendAnalysis {
  padding: 15px;
  & .chartOptions {
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
    & .prog {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      font-size: 16px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    & .custom-checkbox {
      & > input[type="checkbox"] {
        width: 140px;
      }
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;
        &.custom-control-label {
          &::before,
          &::after {
            top: 7px;
            left: -20px;
          }
        }
      }
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
  & .radio-btn {
    & .btn-secondary {
      // color: #807979;
      // background-color: #1445a9;
      // border-color: #758cbd;
      color: #555;
      background-color: #0000003b;
      border: 3px solid #555;
      border-bottom-color: #222;
      border-right-color: #222;
    }
  }
  & .radio-btn {
    & .btn-secondary:not(:disabled):not(.disabled):active,
    .btn-secondary:not(:disabled):not(.disabled).active,
    .show > .btn-secondary.dropdown-toggle {
      color: #fff;
      // background-color: #386bd4;
      background-color: transparent;
    }
  }
  & .data-histogram {
    display: flex;
    flex-direction: row;
    height: 100%;

    & .chart {
      width: calc(100% - 130px);
    }

    & .legend {
      display: flex;
      flex-direction: column;
      width: 130px;
      height: calc(100% - 10px);
      margin-top: 10px;
      // font-size: 15px;
      font-size: 13px;
      color: #d6d6d6;

      & .lvl-1 {
        color: #44ff7c;
      }

      & .lvl-2 {
        color: #f1fd40;
      }

      & .lvl-3 {
        color: #ff5757;
      }
    }
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 200px;
      height: 35px;
      margin-right: 0px;
    }
    .vs__search::placeholder {
      color: #b4b7bd !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/TrendAnalysis.vue